module.exports = __webpack_public_path__ + "img/fish-2.b0b5f3c9.jpg";